import * as React from 'react';
import type { SVGProps } from 'react';

const CheckIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      width="1em"
      height="1em"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="24" height="24" rx="12" fill="#18AB76" />
      <path
        fill="white"
        d="m17.829 9.682-.556-.521a.62.62 0 0 0-.833 0l-5.827 5.464-3.052-2.861a.62.62 0 0 0-.834 0l-.555.52a.53.53 0 0 0 0 .782l4.022 3.77a.605.605 0 0 0 .83 0l6.8-6.373a.526.526 0 0 0 .005-.781Z"
      />
    </svg>
  );
};

export default CheckIcon;
